/**
 * @file index.tsx
 *
 * @fileoverview Renders a hero with a search banner.
 */

import React from 'react';
import { SearchBannerParagraph } from '~/jobiqo/types/types';
import { Image } from '~/jobiqo/components/Image';
import { JobSearchForm } from '~/components/Form/SearchInputForm';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { HeroRow } from '~/vcl/organisms/04-landingpage/02-hero-row';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { Hr } from '~/vcl/atoms/06-layout/10-hr';

export interface SearchBannerProps {
  /**
   * The row to display.
   */
  rowSearchBanner: SearchBannerParagraph;
  /**
   * The index of this row. Used to detect if its the first row on the page.
   */
  index: number;
}

export function SearchBanner({
  rowSearchBanner: {
    searchBannerImage: { url, alt, title, caption },
    searchBannerTextLeft,
    searchBannerTextRight,
  },
  index,
}: SearchBannerProps) {
  return (
    <HeroRow
      boxPosition="left"
      boxContent={
        <Spacing padding={[0, 6, 8]}>
          <Grid columns={'repeat(auto-fit,minmax(200px,1fr))'}>
            {searchBannerTextLeft && (
              <Cell>
                <Text tag="h1" fontSize={[6, 8]} lineHeight={[6, 8]}>
                  {searchBannerTextLeft}
                </Text>
              </Cell>
            )}
            {searchBannerTextRight && (
              <Cell>
                <Text tag="p" fontSize={4} lineHeight={5}>
                  {searchBannerTextRight}
                </Text>
              </Cell>
            )}
          </Grid>
          <Spacing size="medium" />
          <Hr />
          <Spacing margin={11} />

          <JobSearchForm />
        </Spacing>
      }
      image={
        <Image
          src={url}
          alt={alt ?? ''}
          width={null}
          height={null}
          priority={index === 0}
          convertFormat={false}
          {...(title && {
            title,
          })}
          {...(caption && { caption })}
        />
      }
    >
      <Spacing padding={[0, 8]} margin={[0, 4]} />
    </HeroRow>
  );
}
export default SearchBanner;
